import React, { useMemo } from 'react';
import { Timeline, Tween } from 'react-gsap';
import styles from './AudioRecorderAndPlay.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMicrophone } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { t } from '../../translations';

export const RecordingAnimation = ({ isActive, isPulsing, clearPulse, onClick }) => {
  const micButton = useMemo(
    () => (
      <button
        className={`${styles.recordingAnimationMicButton} gss-button`}
        onClick={isPulsing ? null : onClick}
        aria-label={isActive ? t('recordingInProgress') : t('startRecording')}
      >
        <FontAwesomeIcon
          icon={faMicrophone}
          color={isActive ? 'red' : 'black'}
          size={'5x'}
          className={styles.recordingAnimationIcon}
        />
      </button>
    ),
    [isPulsing, isActive]
  );
  let animation = micButton;
  if (isPulsing) {
    animation = (
      <Timeline target={micButton} repeat={1} onComplete={clearPulse}>
        <Tween
          to={{ scale: 1.2, boxShadow: '0 0 0 0px rgba(131, 218, 240, 1)' }}
          duration={0.3}
          ease={'Power0.easeInOut'}
        />
        <Tween
          to={{ scale: 1, boxShadow: '0 0 0 55px rgba(131, 218, 240, 0)' }}
          duration={0.3}
          ease={'Power0.easeInOut'}
        />
      </Timeline>
    );
  } else if (isActive) {
    animation = (
      <Timeline target={micButton} repeat={-1}>
        <Tween
          to={{ scale: 1, boxShadow: '0 0 0 0px rgba(131, 218, 240, 1)' }}
          duration={0.5}
          ease={'Power0.easeInOut'}
        />
        <Tween
          to={{ scale: 1, boxShadow: '0 0 0 30px rgba(131, 218, 240, 0)' }}
          duration={0.5}
          ease={'Power0.easeInOut'}
        />
      </Timeline>
    );
  }
  return <div className={styles.recordingAnimationContainer}>{animation}</div>;
};

RecordingAnimation.defaultProps = {
  isActive: false,
  isPulsing: false,
  clearPulse: () => {},
  onClick: () => {}
};

RecordingAnimation.propTypes = {
  isActive: PropTypes.bool,
  isPulsing: PropTypes.bool,
  clearPulse: PropTypes.func,
  onClick: PropTypes.func
};
